import { useEffect, useRef, useState } from "react";
import mermaid from "mermaid";

mermaid.initialize({
  startOnLoad: false,
  theme: "base",
  themeVariables: {
    background: "#F9F6F0",
    primaryColor: "#F4A261",
    primaryTextColor: "#1A1B41",
    primaryBorderColor: "#1A1B41",
    lineColor: "#1A1B41",
    secondaryColor: "#2A9D8F",
    tertiaryColor: "#E76F51",
    fontFamily: '"Outfit", system-ui, sans-serif',
    fontSize: "14px",
  },
  securityLevel: "loose",
});

export default function MermaidDiagram({ source, testid }) {
  const ref = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!source || !ref.current) return;
    setError(null);
    const id = `mermaid-${Math.random().toString(36).slice(2, 10)}`;
    mermaid
      .render(id, source)
      .then(({ svg }) => {
        if (ref.current) ref.current.innerHTML = svg;
      })
      .catch((e) => {
        setError(e?.message || "Failed to render diagram");
      });
  }, [source]);

  if (!source) return null;
  return (
    <div className="w-full" data-testid={testid || "mermaid-diagram"}>
      {error && (
        <div className="text-xs text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2 mb-3">
          {error}
        </div>
      )}
      <div ref={ref} className="mermaid-render overflow-x-auto p-4 bg-cream rounded-2xl border border-border" />
    </div>
  );
}
